import Color from 'color';
// lighten or darken a provided hsl color based on its difference to
// the ceiling and floor lightness value ( 100 and 0 )
export function alterLightness(color, percentage) {
    var hsl = Color(color.trim()).hsl().array();
    var lightness = hsl[2];
    var difference = percentage > 0 ? 100 - lightness : lightness;
    var newLightness = lightness + difference * percentage;
    var newColor = Color.hsl(hsl[0], hsl[1], newLightness).hex();
    return newColor;
}
// converts any css color format to hex format
export function getHex(color) {
    return color ? Color(color).hex() : '';
}
// return black or white depending on the color luminosity
export function getContrast(color) {
    return Color(color).luminosity() >= 0.5 ? '#000000' : '#FFFFFF';
}
